import React, { useEffect, useState } from 'react';
import { TopNavBar } from './components/Layout/TopNavBar';
import { Sidebar } from './components/Layout/Sidebar';
import { Dashboard } from './components/Dashboard';
import { LandPropertyPage } from './pages/LandPropertyPage';
import { ServiceCataloguePage } from './pages/ServiceCataloguePage';
import { TaxesRevenuePage } from './pages/TaxesRevenuePage';
import { BusinessLicensingPage } from './pages/BusinessLicensingPage';
import { WasteManagementPage } from './pages/WasteManagementPage';
import { WaterSanitationPage } from './pages/WaterSanitationPage';
import { InfrastructurePage } from './pages/InfrastructurePage';
import { PublicSafetyPage } from './pages/PublicSafetyPage';
import { CivilRegistryPage } from './pages/CivilRegistryPage';
import { HealthServicesPage } from './pages/HealthServicesPage';
import { EducationPage } from './pages/EducationPage';
import { EnvironmentalPage } from './pages/EnvironmentalPage';
import { ImmigrationResidencyPage } from './pages/ImmigrationResidencyPage';
import { AgricultureResourcesPage } from './pages/AgricultureResourcesPage';
import { CultureRecreationPage } from './pages/CultureRecreationPage';
import { TransportationPage } from './pages/TransportationPage';
import { EmergencyServicesPage } from './pages/EmergencyServicesPage';
import { CivicEngagementPage } from './pages/CivicEngagementPage';
import { ReportsPage } from './pages/ReportsPage';
import { SettingsPage } from './pages/SettingsPage';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { UserManagementPage } from './pages/admin/UserManagementPage';
import { WorkflowConfigurationPage } from './pages/admin/WorkflowConfigurationPage';
import { TasksPage } from './pages/TasksPage';
import { ServiceConfigurationPage } from './pages/admin/ServiceConfigurationPage';
import { CreateServicePage } from './pages/admin/CreateServicePage';
import { NavigationProvider, useNavigation } from './context/NavigationContext';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { RequestDetailsPage } from './pages/RequestDetailsPage';
import { ListsPage } from './pages/ListsPage';
import { AddEditListPage } from './pages/lists/AddEditListPage';
import { IdentifyCitizenPage } from './pages/assisted-creation/IdentifyCitizenPage';
import { FormFillingPage } from './pages/assisted-creation/FormFillingPage';
import { ServiceRequestFormPage } from './pages/ServiceRequestFormPage';
import { ServiceRequestSuccessPage } from './pages/ServiceRequestSuccessPage';
function AppContent() {
  const {
    currentPath,
    navigate
  } = useNavigation();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [currentUser] = useState({
    name: 'Meseret Bekele',
    role: 'Municipal Administrator',
    avatar: 'https://static.vecteezy.com/system/resources/thumbnails/028/633/357/small/cute-ethiopian-woman-generate-ai-photo.jpeg'
  });
  const [isAuthPage, setIsAuthPage] = useState(false);
  useEffect(() => {
    setIsAuthPage(currentPath.startsWith('/auth'));
  }, [currentPath]);
  const renderContent = () => {
    switch (currentPath) {
      case '/land-property':
        return <LandPropertyPage data-id="element-0" />;
      case '/land-property/services':
        return <ServiceCataloguePage data-id="element-1" />;
      case '/taxes-revenue':
        return <TaxesRevenuePage data-id="element-2" />;
      case '/taxes-revenue/services':
        return <ServiceCataloguePage data-id="element-3" />;
      case '/business-licensing':
        return <BusinessLicensingPage data-id="element-4" />;
      case '/waste-management':
        return <WasteManagementPage data-id="element-5" />;
      case '/water-sanitation':
        return <WaterSanitationPage data-id="element-6" />;
      case '/infrastructure':
        return <InfrastructurePage data-id="element-7" />;
      case '/public-safety':
        return <PublicSafetyPage data-id="element-8" />;
      case '/civil-registry':
        return <CivilRegistryPage data-id="element-9" />;
      case '/health-services':
        return <HealthServicesPage data-id="element-10" />;
      case '/education':
        return <EducationPage data-id="element-11" />;
      case '/environmental':
        return <EnvironmentalPage data-id="element-12" />;
      case '/immigration-residency':
        return <ImmigrationResidencyPage data-id="element-13" />;
      case '/agriculture-resources':
        return <AgricultureResourcesPage data-id="element-14" />;
      case '/culture-recreation':
        return <CultureRecreationPage data-id="element-15" />;
      case '/transportation':
        return <TransportationPage data-id="element-16" />;
      case '/emergency-services':
        return <EmergencyServicesPage data-id="element-17" />;
      case '/civic-engagement':
        return <CivicEngagementPage data-id="element-18" />;
      case '/reports':
        return <ReportsPage data-id="element-19" />;
      case '/admin/users':
        return <UserManagementPage data-id="element-20" />;
      case '/admin/services':
        return <ServiceConfigurationPage data-id="element-21" />;
      // Placeholder for Services Configuration page
      case '/admin/workflow':
        return <WorkflowConfigurationPage data-id="element-22" />;
      // Placeholder for Workflow Configuration page
      case '/settings':
        return <SettingsPage data-id="element-23" />;
      case '/tasks':
        return <TasksPage data-id="element-24" />;
      case '/admin/services/create':
        return <CreateServicePage data-id="element-25" />;
      case '/request-details':
        return <RequestDetailsPage data-id="element-26" />;
      case '/lists':
        return <ListsPage data-id="element-27" />;
      case '/lists/add':
        return <AddEditListPage data-id="element-28" />;
      case '/lists/edit':
        return <AddEditListPage editMode={true} data-id="element-29" />;
      default:
        return <Dashboard userRole={currentUser.role} data-id="element-30" />;
    }
  };
  return <AuthProvider data-id="element-31">
      <BrowserRouter data-id="element-32">
        <div className="flex flex-col h-screen bg-gray-50" data-id="element-33">
          {!isAuthPage && <TopNavBar user={currentUser} data-id="element-34" />}
          <div className="flex flex-1 overflow-hidden" data-id="element-35">
            {!isAuthPage && <Sidebar collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} data-id="element-36" />}
            <main className="flex-1 overflow-auto transition-all duration-200" data-id="element-37">
              <Routes data-id="element-38">
                <Route path="/request-details" element={<ProtectedRoute data-id="element-40">
                      <RequestDetailsPage data-id="element-41" />
                    </ProtectedRoute>} data-id="element-39" />
                <Route path="/assisted-creation/identify-citizen/:serviceId" element={<ProtectedRoute data-id="element-43">
                      <IdentifyCitizenPage data-id="element-44" />
                    </ProtectedRoute>} data-id="element-42" />
                <Route path="/assisted-creation/form-filling/:serviceId/:citizenId" element={<ProtectedRoute data-id="element-46">
                      <FormFillingPage data-id="element-47" />
                    </ProtectedRoute>} data-id="element-45" />
                <Route path="/service-request/:serviceId/:citizenId?" element={<ProtectedRoute data-id="element-49">
                      <ServiceRequestFormPage data-id="element-50" />
                    </ProtectedRoute>} data-id="element-48" />
                <Route path="/service-request-success" element={<ProtectedRoute data-id="element-52">
                      <ServiceRequestSuccessPage data-id="element-53" />
                    </ProtectedRoute>} data-id="element-51" />
                <Route path="*" element={<ProtectedRoute data-id="element-55">{renderContent()}</ProtectedRoute>} data-id="element-54" />
              </Routes>
            </main>
          </div>
        </div>
      </BrowserRouter>
    </AuthProvider>;
}
export function App() {
  return <NavigationProvider data-id="element-56">
      <AppContent data-id="element-57" />
    </NavigationProvider>;
}